import { Command } from 'commands/Commands';

export class ChangeAddressOfficePhone extends Command {
  type: string = 'ChangeAddressOfficePhone';
  priority: number = 100;
}
